import type { ComputedRef } from 'vue'

import { useDisciplineContext } from './discipline-context.hook'

interface DisciplinePageLoaderOptions {
  loading: ComputedRef<boolean>
}

interface DisciplinePageLoaderReturn {
  refIsShown: ComputedRef<boolean>
}

/** One loader per discipline page: the shared discipline read plus whatever the page itself needs to show first. */
export const useDisciplinePageLoader = ({ loading }: DisciplinePageLoaderOptions): DisciplinePageLoaderReturn => {
  const { refIsLoading } = useDisciplineContext()

  const refIsShown = computed<boolean>(() => refIsLoading.value || loading.value)

  return {
    refIsShown,
  }
}
